export default __webpack_public_path__ + "1017bce89c72f95bcf8e2bf4774efdbf.ttf";